import { PlainModal } from '@/components/modals/plain-modal';

import { MODAL_TITLE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const InstallmentModal: Component = ({
  isOpen,
  onClose,
}) => (
  <PlainModal
    className={styles.containerInstallmentModal}
    isOpen={isOpen}
    modalTitle={MODAL_TITLE}
    onClose={onClose}>
    <div>
      Installment figures are based on the monthly sum to be paid on a
      loan amount of 60% or 70% (depending on OMV value) of the vehicle
      listed price over a period of 7 years. For commercial vehicles,
      it is based on 90% loan over a period of 7 years.
      <br />
    </div>
    <div>
      Interest rates are assumed to be at a flat rate of 2.98% per annum,
      which is the car loan interest rate offered by most banks in Singapore.
    </div>
  </PlainModal>
);
